(function() {
    'use strict';

    angular
        .module('app.usuarios-organizador')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/usuarios-organizador',
                config: {
                    templateUrl: 'app/usuarios-organizador/usuariosOrganizador.html',
                    controller: 'UsuariosOrganizador',
                    controllerAs: 'vm',
                    title: 'UsuariosOrganizador',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/editar-usuario-organizador/:id?',
                config: {
                    templateUrl: 'app/usuarios-organizador/editarUsuarioOrganizador.html',
                    controller: 'EditarUsuarioOrganizador',
                    controllerAs: 'vm',
                    title: 'EditarUsuarioOrganizador',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-login"></i> login'
                    }
                }
            },
            {
                url: '/cambiar-password-usuario-organizador/:id/:nombre?',
                config: {
                    templateUrl: 'app/usuarios-organizador/cambiarPasswordUsuarioOrganizador.html',
                    controller: 'CambiarPasswordUsuarioOrganizador',
                    controllerAs: 'vm',
                    title: 'CambiarPasswordUsuarioOrganizador'
                }
            }
        ];
    }
})();
